import React from "react";
import Icon from "./Icon";
import { RowMenu, StatusChip, Switch } from "./controls";
import { groupByFamily } from "./catalogModel";
import { actionState, menuItems, productLabel } from "./ProductActions";
import CourseCell, { CourseActions } from "./CourseCell";

/** Narrow-screen alternative to the table: one card per product, grouped by family. */
export default function ProductCards({ rows, savingKey, errors, onVerify, onToggle, onEdit, course }) {
  return (
    <div className="ac-cards" aria-label="AHA products">
      {groupByFamily(rows).map(([family, list]) => (
        <section key={family}>
          <h4>{family}<span>{list.length}</span></h4>
          {list.map((p) => {
            const { canVerify, canToggle, active } = actionState(p);
            return (
              <article key={p.key} className="ac-card" data-testid={`aha-row-${p.key}`}>
                <div className="top">
                  <div>
                    <b>{p.name}{p.edition && <em> · {p.edition}</em>}</b>
                    <span className="mono">{p.environment?.productNumber ?? "—"} · {p.key}</span>
                  </div>
                  <RowMenu label={`More actions for ${p.name}`} items={menuItems(p, { onEdit, onToggle })} />
                </div>
                <div className="bot">
                  <StatusChip status={actionState(p).status} />
                  {canVerify ? (
                    <button type="button" className="ac-sbtn" disabled={savingKey === p.key} aria-label={`Verify ${productLabel(p)}`} onClick={() => onVerify(p)}>
                      <Icon n="shield" s={14} />Verify
                    </button>
                  ) : (
                    <span className="ac-live">
                      <span className="ac-live-l">Active</span>
                      <Switch on={active} disabled={!canToggle || savingKey === p.key} tip="Reactivate the product first"
                        label={`Active for all training centers: ${p.name}`} onChange={(next) => onToggle(p, next)} />
                    </span>
                  )}
                </div>
                {course && <div style={{ marginTop: 8, display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}><CourseCell product={p} {...course} /><CourseActions product={p} {...course} /></div>}
                {errors[p.key] && <div className="ac-err" role="alert">{errors[p.key]}</div>}
              </article>
            );
          })}
        </section>
      ))}
    </div>
  );
}
